// extracted by mini-css-extract-plugin
var _1 = "_admins-module__btn-container";
var _2 = "_admins-module__title";
export { _1 as "btn-container", _2 as "title" }
